import { useState, useRef, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';
import strFunc from '@/lib/lyg/string';

function WriteInputArea(props: any) {
  let myProps = {
    inside_info: {},
    set_inside_info: (inData: any) => { },
    is_show_wort_stc_select: false,
    ...props
  };
  let inside_info = myProps.inside_info;
  const [sort1_arr, set_sort1_arr] = useState([]);
  const [sort2_arr, set_sort2_arr] = useState([]);
  let select_stu_grade_arr = XcolumnFunc.getSortByTableKey({ 'table': 'user', 'key': 'a_stu_grade' });

  const on_change_input = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    let change_inside_info = { ...inside_info };

    if (name == "a_year" || name == "a_round_num" || name == "a_stu_grade") {
      value = strFunc.uncomma(value);
    }

    change_inside_info[name] = value;

    if (name == "a_sort1") {
      let tmp_select_sort1_seq = "";
      for (let s_i = 0; s_i < sort1_arr.length; s_i++) {
        let tmp_sort_row: any = sort1_arr[s_i];
        if (tmp_sort_row.a_title == value) {
          tmp_select_sort1_seq = tmp_sort_row.a_seq;
        }
      }
      if (tmp_select_sort1_seq) {
        get_sort_arr_by_ajax({
          s_type: "sort2",
          s_par_seq: tmp_select_sort1_seq,
        });
      } else {
        set_sort2_arr([]);
      }
      change_inside_info.a_sort2 = "";
    }

    myProps.set_inside_info(change_inside_info);
  };

  useEffect(() => {
    get_sort_arr_by_ajax({
      s_type: "sort1",
      s_par_seq: "",
    });
  }, []);

  const get_sort_arr_by_ajax = (inData: any) => {
    let tmp_listOpt: any = {
      s_type: "sort1",
      s_par_seq: "",
      ...inData
    };

    let form_json_data: any = {
      ...tmp_listOpt,
      s_mcomp_seq: "1",
      s_par_id: "word_inside_sort",
      order_id:"a_order_num",
      is_paging: "",
    };

    if (form_json_data.s_type != "sort1") {
      if (strFunc.is_empty(form_json_data.s_par_seq)) {
        if (form_json_data.s_type == "sort2") {
          set_sort2_arr([]);
        }
        return false;
      }
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/word/word_inside_sort/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (form_json_data.s_type == "sort1") {
            set_sort1_arr(response.data["data"]["info_arr"]);
            if (inside_info.a_sort1) {
              let tmp_row_select_seq = "";
              for (let s_i = 0; s_i < response.data["data"]["info_arr"].length; s_i++) {
                let tmp_sort_row: any = response.data["data"]["info_arr"][s_i];
                if (tmp_sort_row.a_title == inside_info.a_sort1) {
                  tmp_row_select_seq = tmp_sort_row.a_seq;
                }
              }
              if (tmp_row_select_seq) {
                get_sort_arr_by_ajax({
                  s_type: "sort2",
                  s_par_seq: tmp_row_select_seq,
                });
              }
            }
          } else if (form_json_data.s_type == "sort2") {
            set_sort2_arr(response.data["data"]["info_arr"]);
          }
        } else {

        }
      });
  };

  return (
    <div style={{ marginTop: 20 }}>
      <div style={{ marginBottom: 10, fontSize: 16, fontWeight: 600, color: '#333' }}>
        제목
      </div>
      <input
        type="text"
        name="a_title"
        value={inside_info.a_title}
        onChange={on_change_input}
        placeholder="제목을 입력하세요"
        style={{
          width: '100%',
          padding: '12px 16px',
          border: '1px solid #ddd',
          borderRadius: 8,
          fontSize: 15,
          outline: 'none',
          transition: 'border-color 0.2s',
          boxSizing: 'border-box'
        }}
        autoComplete="off"
        onFocus={(e) => e.target.style.borderColor = '#1976d2'}
        onBlur={(e) => e.target.style.borderColor = '#ddd'}
      />
      {myProps.is_show_wort_stc_select &&
        <div className='mt-1'>
          <select
            value={inside_info.a_word_type}
            name="a_word_type"
            onChange={on_change_input}
            className="w-full px-4 py-3 text-lg border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-white cursor-pointer hover:border-gray-400"
          >
            <option value="word">단어</option>
            <option value="stc">문장</option>
          </select>
        </div>
      }
      <div className='list-table-div mt-1'>
        <table>
          <colgroup>
            <col width={"20%"}></col>
            <col width={"30%"}></col>
            <col width={"20%"}></col>
            <col width={"30%"}></col>
          </colgroup>
          <tbody>
            <tr>
              <th>대분류</th>
              <td>
                <select className='row-input' name="a_sort1" value={inside_info.a_sort1}
                  onChange={on_change_input} >
                  <option value="">선택없음</option>
                  {sort1_arr.map((item: any, idx: number) => {
                    return (
                      <option key={idx} value={item.a_title}>{item.a_title}</option>
                    )
                  })}
                </select>
              </td>
              <th>중분류</th>
              <td>
                <select className='row-input' name="a_sort2" value={inside_info.a_sort2}
                  onChange={on_change_input} >
                  <option value="">선택없음</option>
                  {sort2_arr.map((item: any, idx: number) => {
                    return (
                      <option key={idx} value={item.a_title}>{item.a_title}</option>
                    )
                  })}
                </select>
              </td>
            </tr>
            <tr>
              <th>학년</th>
              <td>
                <select className='row-input' name="a_stu_grade" value={inside_info.a_stu_grade}
                  onChange={on_change_input}
                  style={{ width: "100px" }}>
                  <option value="">선택없음</option>
                  {select_stu_grade_arr.map((item: any, idx: number) => {
                    return (
                      <option key={idx} value={item.value}>{item.text}</option>
                    )
                  })}
                </select>
              </td>
              <th>책제목</th>
              <td>
                <input type='text' className='row-input' name="a_book_title" value={inside_info.a_book_title}
                  onChange={on_change_input} />
              </td>
            </tr>
            <tr>
              <th>단원</th>
              <td>
                <input type='text' className='row-input' name="a_book_section" value={inside_info.a_book_section}
                  onChange={on_change_input} />
              </td>
              <th>유닛</th>
              <td>
                <input type='text' className='row-input' name="a_book_unit" value={inside_info.a_book_unit}
                  onChange={on_change_input} />
              </td>
            </tr>
            <tr>
              <th>년도</th>
              <td>
                <input type='number' className='row-input' name="a_year" value={inside_info.a_year}
                  onChange={on_change_input} />
              </td>
              <th>회차</th>
              <td>
                <input type='number' className='row-input' name="a_round_num" value={inside_info.a_round_num}
                  onChange={on_change_input} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default WriteInputArea;